import { render, staticRenderFns } from "./SentVideos.vue?vue&type=template&id=9332f304&"
import script from "./SentVideos.vue?vue&type=script&lang=js&"
export * from "./SentVideos.vue?vue&type=script&lang=js&"
import style0 from "./SentVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports